import { Link } from "react-router-dom"
import styled from "styled-components"
import Header from "../Common/Header"
import Footer from "../Common/Footer"

const Main = styled.main`
  min-height: 58vh;
  display: grid;
  place-items: center;
  padding: clamp(5rem, 12vw, 9rem) 1.5rem;
  background: linear-gradient(160deg, #f5f8fb 0%, #e8f0f8 100%);
`

const Card = styled.div`
  width: min(680px, 100%);
  text-align: center;
  display: grid;
  justify-items: center;
  gap: 1rem;

  span {
    color: ${({ theme }) => theme.primary};
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
  }

  h1 {
    color: ${({ theme }) => theme.primaryDark};
    font-size: clamp(2.2rem, 7vw, 4rem);
  }

  p {
    max-width: 540px;
    font-size: 1.1rem;
  }
`

const HomeLink = styled(Link)`
  display: inline-flex;
  padding: 0.9rem 1.4rem;
  border-radius: 2px;
  background: ${({ theme }) => theme.primaryDark};
  color: #fff;
  text-decoration: none;
  font-weight: 700;
`

const NotFound = () => (
  <>
    <Header />
    <Main id="contenu-principal">
      <Card>
        <span>Erreur 404</span>
        <h1>Cette page n’existe pas.</h1>
        <p>Le lien a peut-être changé. Revenez à l’accueil pour consulter nos services ou nous contacter.</p>
        <HomeLink to="/">Retour à l’accueil</HomeLink>
      </Card>
    </Main>
    <Footer />
  </>
)

export default NotFound
